module.exports = __webpack_public_path__ + "static/img/logo01.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo01.png
// module id = ywVb
// module chunks = 1